<script setup lang="ts">
import { computed } from 'vue'

import { getParticipantTeamSide } from '@collector/shared-ui-domain'
import { Participant } from '@collector/sportsapi-client-legacy'
import { useSwitchTeamColors } from '@desktop/views/Relation/composables'

interface Props {
  participant: Participant
}

const props = defineProps<Props>()

// composables
const { getTeamSideColor } = useSwitchTeamColors()

// computed
const teamSide = computed(() => getParticipantTeamSide(props.participant))
const teamSideColor = computed(() => getTeamSideColor(teamSide.value))
</script>

<template>
  <div
    class="h-6 overflow-hidden rounded-sm px-2 text-center text-xs leading-6 font-bold text-ellipsis whitespace-nowrap select-none"
    :class="{
      'bg-current-team-home-5': teamSide === 'home',
      'text-neutral-dark-0': teamSideColor === 'home',

      'bg-current-team-away-5': teamSide === 'away',
      'text-neutral-light-10': teamSideColor === 'away',
    }"
  >
    {{ participant.short_name }}
  </div>
</template>
